import React from 'react'
// import ProductsSection from '../../sections/ProductsSection/products/products'
import ProductsBanner from '../../sections/ProductsSection/products/productss-banner/products-banner'

import PaperBagGallery from '../../sections/HomeSection/Home-products-2/home-products-2'


const ProductsPage=()=>{
    return(
        <div>
            {/* <ProductsSection/> */}
            <ProductsBanner/>

            <PaperBagGallery/>

        </div>
    )
}

export default ProductsPage